import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'identifierColumnDisabled',
})
export class IdentifierColumnDisabledPipe implements PipeTransform {
  transform(linkedItemDeleted: boolean, hasAccessToHierarchy: boolean): boolean {
    if (linkedItemDeleted === true || hasAccessToHierarchy === false) {
      return true;
    }
    return false;
  }
}
